import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, Row} from "react-bootstrap";
import DropdownItemsInput from "./DropdownItemsInput";
import task_type from "../assets/json/task_type.json";
import assign_list from "../assets/json/assign_to_list.json";
import Calendar from "./Icons/Calendar";
import Trash from "./Icons/Trash";
import {useSelector} from "react-redux";
import InfoCircle from "./Icons/InfoCircle";

function DynamicProcessTemplate(props) {
    const notesTypeRef = useRef();
    const taskTypeRef = useRef();
    const fullNameRef = useRef();
    const emailRef = useRef();
    const [teacher, setTeacher] = useState([]);
    const [taskType, setTaskType] = useState([]);
    const [isValidEmail, setIsValidEmail] = useState(false);
    const [isValidEmailMaxLength, setIsValidEmailMaxLength] = useState(true);
    const [isValidFullNameMaxLength, setIsValidFullNameMaxLength] = useState(true);
    const maxLength = 100;

    const [fieldIsValid, setFieldIsValid] = useState({
        isTaskValid: false,
        isAssignValid: false,
        isNotesValid: false,
    });

    useEffect(() => {
        if (props.task_name !== "") {
            setFieldIsValid(prevState => ({
                ...prevState,
                isTaskValid: true
            }));
        }

        if (props.note !== "") {
            setFieldIsValid(prevState => ({
                ...prevState,
                isNotesValid: true
            }));
        }
    }, [props.task_name, props.note]); // Note: added dependencies to the dependency array


    const getTeacherList = useSelector(state => state.getTeacherAssociate)
    const {teacher_list} = getTeacherList

    useEffect(() => {
        if (!getTeacherList.teacher_list <= 0) {
            // console.log(getTeacherList.teacher_list)
            getTeacherList.teacher_list.map((item, index) => {
                setTeacher((prevData) => [
                    ...prevData,
                    {
                        id: item.employee_ID,
                        data: `${item.employee_First_Name} ${item.employee_Last_Name}`,
                    }
                ])
            });
        }
    }, [getTeacherList.teacher_list]);

    useEffect(() => {
        if (props.assignToEmail) {
            const isValidEmail = validateEmail(props.assignToEmail);
            setIsValidEmail(isValidEmail);
        }
    }, [props.assignToEmail]);

    const getTaskTypeList = useSelector(state => state.getTaskType)
    const {task_type_list} = getTaskTypeList

    useEffect(() => {
        if (!getTaskTypeList.task_type_list <= 0) {
            getTaskTypeList.task_type_list.map((item, index) => {
                setTaskType((prevData) => [
                    ...prevData,
                    {
                        id: item.taskId,
                        data: item.title,
                    }
                ])
            });
        }
    }, [getTaskTypeList.task_type_list]);
    const notesKeyPress = (event, task) => {
        event.preventDefault();
        if (!/^(?=.*[a-zA-Z\d\n].*)[a-zA-Z \d!@#$%&*,-]{1,1000}$/.test(notesTypeRef.current.value)) {
            setFieldIsValid({
                ...fieldIsValid,
                isNotesValid: false,
            });
            props.result("3",notesTypeRef.current.value,task)
            return;
        } else {
            setFieldIsValid({
                ...fieldIsValid,
                isNotesValid: true,
            });
            props.result(["3",notesTypeRef.current.value,task])
        }
    }
    const taskKeyPress = (event, task) => {
        event.preventDefault();
        if (!/^(?=.*[a-zA-Z\d\n].*)[a-zA-Z \d!@#$%&*,-]{1,1000}$/.test(taskTypeRef.current.value)) {
            setFieldIsValid({
                ...fieldIsValid,
                isTaskValid: false,
            });
            props.result("1",taskTypeRef.current.value,task)
            return;
        } else {
            setFieldIsValid({
                ...fieldIsValid,
                isTaskValid: true,
            });
            props.result(["1",taskTypeRef.current.value,task])
        }
    }

    function checkMaxLength(str, max) {
        return str.length <= max;
    }

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const fullNameChange = (event, task) => {
        event.preventDefault();
        const isMaxLengthValid = checkMaxLength(fullNameRef.current.value, maxLength);
        setIsValidFullNameMaxLength(isMaxLengthValid);
        props.result(["4", isMaxLengthValid ? fullNameRef.current.value : '', task]);
    }

    const emailChange = (event, task) => {
        event.preventDefault();
        const isValidEmail = validateEmail(emailRef.current.value);
        const isMaxLengthValid = checkMaxLength(emailRef.current.value, maxLength);
        setIsValidEmail(isValidEmail);
        setIsValidEmailMaxLength(isMaxLengthValid);
        props.result(["5", (isValidEmail && isMaxLengthValid) ? emailRef.current.value : '', task]);
    }

    const assignData = (data, task) => {
        props.result(["2",data.id, task])
    }
    function taskDelete(task) {
        props.result(["0", task])
    }
    const updateIsEmailType = (value, task) => {
        props.result(["6", value, task]);
    }

    return (
        <>
            <Row className="background-1 border-bottom-div pb-4" key={props.task}>
                <Row className="background-1 pt-4">
                    <div className="col-6 float-left-child template-card-title padding-left-unset">
                        Task {props.task}
                    </div>
                    {props.count > 1 && <div onClick={() => taskDelete(props.task)}
                          className="col-6 float-right-child template-card-title template-card-text-right padding-right-unset button-cursor">
                        <Trash className="sidebar-icon-form"
                               color="var(--red)"/> <span className="message-6">Delete</span>
                    </div>}
                </Row>
                <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}
                     className="padding-left-unset">
                    <div className="document-form">
                        <label htmlFor="document_title" id="teacher-associate"
                               className="form-label form-spacing">
                            Tasks<span className="asterics">*</span></label>
                        <input ref={taskTypeRef} onKeyUp={(e) => taskKeyPress(e, props.task)}
                               type="text" autoComplete="off"
                               defaultValue={props.task_name}
                               className={!fieldIsValid.isTaskValid ?
                                   "input-error-form input-spacing" : "input-valid-form input-spacing"}
                               placeholder="Enter Task Type"
                               id="document_title"/>
                    </div>
                </Col>
                <Row className="background-1">
                    <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}
                         className="padding-left-unset padding-right-unset">
                        <div className="document-form">
                            <div className="label-form-checkbox">
                                Send Task By:
                            </div>
                            <div className="form-checkbox email-type">
                                <Form.Check
                                    className="float-left-child se-form"
                                    name={"hardcopy" + props.task}
                                    label="Assignee"
                                    type="radio"
                                    id={"hardcopy" + props.task}
                                    defaultChecked={!props.isEmailAssignment}
                                    onClick={() => updateIsEmailType(false, props.task)}
                                />
                                <Form.Check
                                    className="float-right-child se-form"
                                    name={"hardcopy" + props.task}
                                    label="Email"
                                    type="radio"
                                    id={"hardcopy" + props.task}
                                    defaultChecked={props.isEmailAssignment}
                                    onClick={() => updateIsEmailType(true, props.task)}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                {!props.isEmailAssignment
                    ? (
                        <Col lg={{span: 6, offset: 0}} md={{span: 6, offset: 0}}
                             className="padding-left-unset">
                            <div className="document-form">
                                <label htmlFor="document_title" id="teacher-associate"
                                       className="form-label form-spacing">
                                    Assign To<span className="asterics">*</span></label>
                                <div>
                                    <DropdownItemsInput data={teacher} result={(data) => assignData(data, props.task)} value={props.assign}
                                                        className={props.assign !== '' ?
                                                            "background-1 dropdown-input-content-valid" : "background-1 dropdown-input-content"}
                                                        title="Select Assign To"/>
                                </div>
                            </div>
                        </Col>
                    )
                    : (
                        <Row className="background-1">
                            <Col lg={{span: 6, offset: 0}} md={{span: 6, offset: 0}}
                                 className="padding-left-unset">
                                <div className="document-form">
                                    <label htmlFor="user_full_name" id="teacher-associate"
                                           className="form-label form-spacing">
                                        Full Name<span className="asterics">*</span></label>
                                    <input ref={fullNameRef}
                                           defaultValue={props.assignToEmailFullName}
                                           onChange={(e) => fullNameChange(e, props.task)}
                                           type="text" autoComplete="off"
                                           className="input-error-form input-spacing"
                                           placeholder="Add Full Name"
                                           id="user_full_name"/>
                                </div>
                                {!isValidFullNameMaxLength &&
                                    <div className="error-message mt-2">
                                        Max length exceeded
                                    </div>
                                }
                            </Col>
                            <Col lg={{span: 6, offset: 0}} md={{span: 6, offset: 0}}
                                 className="padding-right-unset">
                                <div className="document-form">
                                    <label htmlFor="user_email" id="teacher-associate"
                                           className="form-label form-spacing">
                                        Email<span className="asterics">*</span></label>
                                    <input ref={emailRef}
                                           defaultValue={props.assignToEmail}
                                           onChange={(e) => emailChange(e, props.task)}
                                           type="text" autoComplete="off"
                                           className="input-error-form input-spacing"
                                           placeholder="Add Email Adress"
                                           id="user_email"/>
                                </div>
                                { !isValidEmailMaxLength &&
                                    <div className="error-message mt-2">
                                        Max length exceeded
                                    </div>
                                }
                                { !isValidEmail &&
                                    <div className="error-message-div mt-2">
                                        <InfoCircle className="sidebar-icon-form" color="var(--red)"/>
                                        <span> Note: Please add correct email.</span>
                                    </div>
                                }
                            </Col>
                        </Row>
                    )
                }

                <Col lg={{span: 12, offset: 0}} md={{span: 12, offset: 0}}
                     className="padding-right-unset padding-left-unset">
                    <div className={!fieldIsValid.isNotesValid ? "document-form-textarea-error"
                        : "document-form-textarea"}
                    >
                                                <span className="text-label form-spacing">
                                                    Note<span className="asterics">*</span></span>
                        <textarea ref={notesTypeRef} onKeyUp={(e) => notesKeyPress(e, props.task)} defaultValue={props.note}
                                  className="textarea-input-error textarea-spacing"
                                  placeholder="Add Notes" rows="4"
                                  id="document_title"/>
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default DynamicProcessTemplate;